import { axiosInstance } from ".";
import { GuideDetails } from "../@types";

export async function getUserGuide(): Promise<GuideDetails> {
  return (await axiosInstance.get(`/guide`)).data;
}

export async function getTeaserContent(): Promise<any> {
  return (await axiosInstance.get(`/content/teaser`)).data;
}
export async function getCoachRecommendations(): Promise<any> {
  return (await axiosInstance.get(`/content/coach-recommendations`)).data;
}

export async function getUserAppointments(): Promise<any> {
  return (await axiosInstance.get(`/users/appointments`)).data;
}
